<template>
  <div class="login-wrapper auth-visual-shell">
    <img :src="backgroundSrc" alt="fundo" class="background-image">

    <section class="login-container auth-visual-shell__card" aria-live="polite">
      <router-link :to="homeTo" class="auth-visual-shell__logo-link" aria-label="Voltar para a pagina inicial">
        <img :src="logoSrc" :alt="logoAlt" class="logo">
      </router-link>

      <slot />

      <img
        v-if="characterSrc"
        :src="characterSrc"
        :alt="characterAlt"
        :class="['character-image', characterClass]"
      >
    </section>

    <div class="bd-degrade" :style="{ background: gradient }"></div>
  </div>
</template>

<script>
export default {
  name: 'AuthVisualShell',
  props: {
    backgroundSrc: {
      type: String,
      default: () => require('@/assets/images/bg.png'),
    },
    characterSrc: {
      type: String,
      default: '',
    },
    characterAlt: {
      type: String,
      default: '',
    },
    characterClass: {
      type: String,
      default: '',
    },
    gradient: {
      type: String,
      default: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.644), #b67f07d8)',
    },
    logoSrc: {
      type: String,
      default: () => require('@/assets/images/Rectangle 3.png'),
    },
    logoAlt: {
      type: String,
      default: 'Logo Zinnes',
    },
    homeTo: {
      type: [String, Object],
      default: '/',
    },
  },
};
</script>

<style>
.auth-visual-shell.login-wrapper {
  position: relative;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background-color: #000000bb;
  padding: 24px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.auth-visual-shell .background-image {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
}

.auth-visual-shell .bd-degrade {
  position: absolute;
  inset: 0;
  height: 100%;
  width: 100%;
  z-index: 2;
  pointer-events: none;
}

.auth-visual-shell .login-container {
  position: relative;
  width: min(100%, 600px);
  background-color: rgba(255, 255, 255, 0.92);
  border-radius: 10px;
  padding: 40px;
  text-align: center;
  box-shadow:
    0 0 0 1px rgba(255, 255, 255, 0.45),
    0 18px 50px rgba(0, 0, 0, 0.28),
    0 4px 18px rgba(0, 0, 0, 0.18);
  z-index: 3;
}

.auth-visual-shell .auth-visual-shell__logo-link {
  display: inline-flex;
  min-height: 44px;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}

.auth-visual-shell .logo {
  width: 150px;
  max-width: 70%;
  margin-bottom: 20px;
}

.auth-visual-shell .login-content h2 {
  font-weight: bold;
  margin-bottom: 20px;
  text-wrap: balance;
}

.auth-visual-shell .login-content p {
  margin-bottom: 30px;
  color: #555;
  text-wrap: pretty;
}

.auth-visual-shell .character-image {
  position: absolute;
  left: -200px;
  bottom: 0;
  height: 560px;
  z-index: -1;
  pointer-events: none;
}

.auth-visual-shell .btn-login {
  margin-bottom: 14px;
  width: 45%;
  min-width: 160px;
  color: #fff !important;
  font-size: 19px;
  font-weight: 700;
  transition-property: transform, box-shadow;
  transition-duration: 150ms;
  transition-timing-function: ease-out;
}

.auth-visual-shell .btn-login:active {
  transform: scale(0.96);
}

.auth-visual-shell a {
  color: orange;
  text-decoration: none;
}

.auth-visual-shell .forgot-password {
  text-align: end;
}

.auth-visual-shell .character-image--register {
  left: 490px;
  height: 660px;
  z-index: -1;
}

@media (max-width: 540px) {
  .auth-visual-shell.login-wrapper {
    padding: 0;
  }

  .auth-visual-shell .login-container {
    width: 100%;
    min-height: 100vh;
    max-height: none;
    border-radius: 0;
    padding: 28px 22px;
  }

  .auth-visual-shell .background-image {
    display: none;
  }

  .auth-visual-shell .btn-login {
    width: 100%;
    font-size: 16px;
  }
}

@media (max-width: 430px) {
  .auth-visual-shell .character-image {
    display: none;
  }
}
</style>
